<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="用户名/手机"/>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="调用次数">
                <a-input-number v-model="queryParam.callNo" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="更新日期">
                <a-date-picker v-model="queryParam.date" style="width: 100%" placeholder="请输入更新日期"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select v-model="queryParam.useStatus" placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">

    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="name" slot-scope="name,record">
        <img :src="record.face" style="width: 40px; vertical-align: middle;" /> {{record.name}}
      </span>
      <span slot="orderCount" slot-scope="order_count,record">
        {{record.order_count}}笔 / {{record.order_total_price}}元
      </span>
      <span slot="action" slot-scope="text, record">
        <template >
          <a @click="handleEdit(record)"  >编辑</a>
          <a-divider type="vertical" />
        </template>
        <a-dropdown>
          <a class="ant-dropdown-link">
            更多 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
                <a-popconfirm title="确定重置为123456" @confirm="resetPassword(record)"  okText="确定" cancelText="取消">
    <a href="javascript:;">重置密码</a>
  </a-popconfirm>
            </a-menu-item>
            <!-- <a-menu-item>
               <a @click="handleLogManage(record)">积分管理</a>
            </a-menu-item> -->
          </a-menu>
        </a-dropdown>
      </span>
    </s-table>

    <a-modal
        :maskClosable="false"
      title="操作"
      :width="800"
      v-model="visible"
      @ok="handleOk"
      >
      <a-spin :spinning="saveLoading">
      <a-form :form="form">
        <a-form-item
           v-show="false"
        >
          <a-input  style="width: 100%" v-decorator="[
          'id',
          {rules: [ ]}
        ]" />
        </a-form-item>

        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="用户名"
          hasFeedback
        >
          <a-input v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入用户名' }]}
        ]"
         placeholder="请输入用户名"/>
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="手机号"
                hasFeedback
        >
          <a-input v-decorator="[
          'phone',
          {rules: [{ required: true, message: '请输入手机号' }]}
        ]"
                   placeholder="请输入手机号" />
        </a-form-item>
        <a-form-item
            label="头像"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <pic-uploader :file-list="formData.face_pic"   />
        </a-form-item>

        <a-form-item
            label="企业微信图片"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <pic-uploader :file-list="formData.weixin_pic" />
        </a-form-item>
        
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="是否允许签约合伙人"
                hasFeedback
        >
          <r-switch :formData="formData" field="can_apply_partner" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
        </a-form-item>
        <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="开通为合伙人"
                hasFeedback
        >
          <r-switch :formData="formData" field="is_partner" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
        </a-form-item>

          <a-form-item :labelCol="labelCol"
                       :wrapperCol="wrapperCol"
                       hasFeedback
                       v-if="formData.is_partner == 1"
                       label="所属地区">
            <a-cascader :options="areaOptions" placeholder="请选择地区" v-model="formData.areas" changeOnSelect
            />
          </a-form-item>

           <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="仓库账号"
                hasFeedback
        >
          <r-switch :formData="formData" field="is_warehouse_user" :checkedValue="1" :unCheckedValue="2" checkedChildren="是" unCheckedChildren="否" />
        </a-form-item>

      </a-form>
        </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
            title="明细管理"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="scoreVisible"
            @ok="scoreVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="logColumns" :dataSource="logList" :pagination="scorePagination"
                   @change="handleLogTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <template slot="footer" slot-scope="currentPageData">
              <div>
                <PriceInput  style="width: 200px; margin-right: 10px;" :formData="scoreFormData"
                             field="change"
                             placeholder="调整积分"/>
                <a-input style="width: 200px; margin-right: 10px;" v-model="scoreFormData.note" placeholder="请输入理由" />
                <!--</a-select>-->
                <a-button icon="edit" @click="scoreEdit" >修改积分</a-button>
              </div>
              <!-- <div style="margin: 10px 0 0 0">
                <PriceInput  style="width: 200px; margin-right: 10px;" :formData="blockFormData"
                             field="amount"
                             placeholder="冻结余额"/>
                <a-input style="width: 200px; margin-right: 10px;" v-model="blockFormData.note" placeholder="请输入理由" />
                <a-button icon="edit" @click="blockedEdit" >冻结余额</a-button>
              </div> -->
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>
  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import moment from 'moment'
  import areaOptions from '@/utils/area'

  import PriceInput from '@/components/PriceInput/'
  import {  scoreLogList,scoreEdit } from '@/api/score'

  import RSwitch from '@/components/RSwitch/'
  import { getUserList ,getUserDetail,editUser,getUserGroupList,setPassword } from '@/api/user'
  import PicUploader from '@/components/PicUploader/'
  export default {
    name: 'UserList',
    components: {
      AInput,
      ATextarea,
      RSwitch,
      STable,
      PriceInput,
      PicUploader
    },
    data () {
      return {
        areaOptions,
        saveLoading:false,
        visible: false,
//        description: '全校班级管理。',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        groupOptions:[],
        formData:{
          can_apply_partner: 2,
          is_partner: 2,
          is_warehouse_user:2,
          areas:[],
          weixin_pic:[],
          face_pic:[],
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            sorter: true
          },
          {
            title: '用户名',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '手机号',
            dataIndex: 'phone'
          },
          {
            title: '用户组',
            dataIndex: 'user_group_name',
            filters: [
              {
                text: '普通',
                value: '0'
              },
              {
                text: '多媒体',
                value: '1'
              }],
          },
          // {
          //   title: '订单 / 消费',
          //   dataIndex: 'order_count',
          //   scopedSlots: { customRender: 'orderCount' },
          // },
          {
            title: '注册时间',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '150px',
            scopedSlots: { customRender: 'action' },
          }
        ],

        logList:[],

        //管理表头
        logColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '交易积分',
            width:'150px',
            dataIndex: 'change',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '积分',
            width:'150px',
            dataIndex: 'score1',
            customRender: (text) =>  {
              return parseFloat(text).toFixed(2);
            }
          },
          {
            title: '类型',
            dataIndex: 'title',
            width:'100px',
          },
          {
            title: '附加信息',
            dataIndex: 'extra_note',
            width:'200px',
          },
          {
            title: '时间',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
        ],
        scoreVisible:false,
        scorePagination:{
            current: 1,
            pageSize:10,
            showTotal: (total) =>{
              return '总计'+total+'条'
            }
        },
        scoreQuery:{
          user_id:0,
          score:'score1',
          pageSize:10,
          pageNo:1
        },
        scoreFormData:{
          user_id:undefined,
          change:undefined,
          note:undefined
        },
        blockFormData:{
          account_id:undefined,
          amount:undefined,
          note:undefined
        },
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam.user_group_ids = [];
          if(parameter.user_group_name && parameter.user_group_name.length){
            this.queryParam.user_group_ids =  parameter.user_group_name;
          }
          this.queryParam = Object.assign(this.queryParam,parameter);
          return getUserList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    created () {
//      getRoleList({ t: new Date()})
    },
    mounted(){
    let self = this;
      getUserGroupList().then(res => {
        self.groupOptions = [];
        console.log(res.data);
        res.data.map(function (item,index) {
          self.groupOptions.push({
            text : item.name,
            value : item.id+'',
          })
        });
        self.columns[3].filters = self.groupOptions;
      })
    },
    methods: {

      handleLogManage(record) {
        let self = this
        self.scoreQuery.user_id = record.id;
        self.scoreFormData.user_id=record.id
        self.scorePagination.current = 1;
        self.fetchLogList();
        this.scoreVisible = true
      },
      fetchLogList(){
        let self = this
        scoreLogList(self.scoreQuery).then(res => {
          self.logList = res.data.list

//          const pagination = { ...self.scorePagination };
          // Read total count from server
//           pagination.total = res.data.total;
          self.$set(self.scorePagination,'total',res.data.total);
//          self.scorePagination.total = res.data.total;
//          pagination.total = 200;
//          self.scorePagination = pagination;
        })
      },
      handleLogTableChange(pagination, filters, sorter){
        let that = this;
        that.scoreQuery.pageNo = pagination.current;
        that.$set(that.scorePagination,'current',pagination.current);
        that.fetchLogList();
      },
      scoreEdit(){
        let that = this;
        scoreEdit(that.scoreFormData).then(res => {
          that.$message.success('修改成功')
          that.fetchLogList();
          that.$refs.table.refresh()
          that.scoreVisible = false;
          that.scoreFormData = {
            user_id:undefined,
                    amount:undefined,
                    note:undefined
          };
        }).catch(err =>{
          that.$message.error(err.data.msg);
        })
      },


      handleCancel(){
        this.visible = false
      },
     // 增
    handleAdd() {
      this.visible = true
      this.form.resetFields()
    },
    // 改
    handleEdit(record) {
      let self = this
      getUserDetail({ id: record.id }).then(res => {

        self.form.setFieldsValue({ ...res.data })
        self.formData.id = record.id;
        self.formData.can_apply_partner = res.data.can_apply_partner
        self.formData.is_partner = res.data.is_partner
        self.formData.is_warehouse_user = res.data.is_warehouse_user

        if(res.data.area){
          res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
        }else{
          res.data.areas = [];
        }
        self.formData.areas = res.data.areas
        // self.formData.weixin_pic = res.data.weixin_pic



        self.formData = {...res.data};
        self.formData.face_pic = [
          {
            name:res.data.face,
            save_name:res.data.face,
            uid:res.data.face,
            url:res.data.face, 
          }
        ]
        console.log('self.formData.face_pic',self.formData.face_pic)
      })
      // console.log(this.mdl)
      this.visible = true
    },
    // 增改 处理
    handleOk(e) {
      let self = this
      e.preventDefault()
      if(self.formData.face_pic.length==0){
            self.$message.error('头像不能为空') 
            return ;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values, self.formData)
          self.saveLoading = true;
          if (values.id) {
            values.can_apply_partner = self.formData.can_apply_partner
            values.weixin_pic = self.formData.weixin_pic
            values.face_pic = self.formData.face_pic
            values.is_partner = self.formData.is_partner
            values.is_warehouse_user = self.formData.is_warehouse_user
            
            values.area = self.formData.areas[self.formData.areas.length-1]
            editUser(values).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false
              self.saveLoading = false;
            }).catch(err =>{
              self.saveLoading = false;
              self.$message.error(err.data.msg)
            })
          }
        }
      })
    },
        // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },
     // 删
      resetPassword(record) {
        let self = this
        setPassword({ id: record.id ,password:123456}).then(res => {
          self.$message.success('重置成功')
      })
    },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },

      resetSearchForm () {
        this.queryParam = {
          date: moment(new Date())
        }
      }
    },
    watch: {
      /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
    }
  }
</script>
